/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['[_nghost-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;width:100%;position:fixed;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.content[_ngcontent-%COMP%]{margin-left:100px;height:100%;padding-top:12%;width:276px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL3B1YmxpYy1sYXlvdXQvcHVibGljLWxheW91dC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9sYXlvdXQvY29tcG9uZW50cy9wdWJsaWMtbGF5b3V0L3B1YmxpYy1sYXlvdXQuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/public-layout/public-layout.component.scss.shim.ngstyle.ts